import React from 'react';
import '../../scss/_cost-data.scss';
import { AddRowActionsFooter, IAddRowAction } from './AddRowActions';
import {
  CostDataHeader,
  AmountHeader,
  BuyerBeforeHeader,
  BuyerClosingHeader,
  DeleteHeader,
  EmptyCellHeader,
  LenderPaidHeader,
  NameHeader,
  NettedOutHeader,
  OthersHeader,
  PayeeHeader,
  RowNumberHeader,
  SellerBeforeHeader,
  SellerClosingHeader,
  ToHeader,
} from './Items/StyledCdItemCells';
import { IHasTestData } from '../../ui-toolkit/test-utilities/IHasTestData';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';

export interface ICostDataProps extends IHasTestData {
  addRowActions?: IAddRowAction[];
  className?: string;
  mode?: 'default' | 'seller' | 'payoff';
  showLenderPaid?: boolean;
  showNettedOut?: boolean;
  style?: React.CSSProperties;
  addRowActionsDisabled?: boolean;
  children?: React.ReactNode;
  sendingToLabel?: string;
}

export default class CostData extends React.Component<ICostDataProps> {
  public static defaultProps = {
    mode: 'default',
    showLenderPaid: true,
    showNettedOut: true,
    sendingToLabel: 'Sending to Spruce',
  };

  public render() {
    const {
      addRowActions,
      children,
      mode,
      style,
      showLenderPaid,
      showNettedOut,
      addRowActionsDisabled,
      sendingToLabel,
      'data-test-id': dataTestID,
    } = this.props;
    const showSeller = mode === 'seller';
    const showPayoff = mode === 'payoff';
    return (
      <div data-test-id={mergeTests(dataTestID, 'wrapper')} style={style}>
        <CostDataHeader showPayoff={showPayoff} showSeller={showSeller}>
          <RowNumberHeader>No.</RowNumberHeader>
          <NameHeader>Name</NameHeader>
          {showPayoff && <ToHeader />}
          {showPayoff && <PayeeHeader>Payee</PayeeHeader>}
          {!showPayoff && <BuyerClosingHeader>At closing</BuyerClosingHeader>}
          {!showPayoff && <BuyerBeforeHeader>Before</BuyerBeforeHeader>}
          {showSeller && <SellerClosingHeader>At closing</SellerClosingHeader>}
          {showSeller && <SellerBeforeHeader>Before</SellerBeforeHeader>}
          {!showPayoff && <OthersHeader />}
          {showPayoff && <EmptyCellHeader />}
          {showPayoff && <AmountHeader>Amount</AmountHeader>}
          <NettedOutHeader>{showNettedOut && 'Netted Out'}</NettedOutHeader>
          <LenderPaidHeader>{showLenderPaid && sendingToLabel}</LenderPaidHeader>
          <DeleteHeader />
        </CostDataHeader>
        <div className="cost-data__body" data-test-id={mergeTests(dataTestID, 'data-rows')}>
          {children}
        </div>
        {addRowActions && addRowActions.length ? (
          <AddRowActionsFooter
            disabled={addRowActionsDisabled}
            data-test-id={mergeTests(dataTestID, 'action')}
            addRowActions={addRowActions}
          />
        ) : null}
      </div>
    );
  }
}
